// units.js — fetch + cache (offline) the seeded units, skills and registry from the backend.
import { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;
const cacheKey = (p) => `mwq_cache_${p}`;

export async function cachedGet(path, { ttlMs = 6 * 3600 * 1000 } = {}) {
  let cached = null;
  try { cached = JSON.parse(localStorage.getItem(cacheKey(path)) || "null"); } catch { /* ignore */ }
  if (cached && Date.now() - cached.at < ttlMs) return cached.data;
  try {
    const r = await fetch(`${API}/api${path}`);
    if (!r.ok) throw new Error(String(r.status));
    const data = await r.json();
    try { localStorage.setItem(cacheKey(path), JSON.stringify({ at: Date.now(), data })); } catch { /* quota */ }
    return data;
  } catch (e) {
    if (cached) return cached.data;
    throw e;
  }
}

export function useCached(path, deps = []) {
  const [state, set] = useState({ data: null, loading: true, error: null });
  useEffect(() => {
    let live = true;
    set((s) => ({ ...s, loading: true }));
    cachedGet(path).then((data) => live && set({ data, loading: false, error: null })).catch((e) => live && set({ data: null, loading: false, error: e }));
    return () => { live = false; };
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps
  return state;
}

export const useUnits = () => useCached("/units");
export const useUnit = (id) => useCached(`/units/${id}`, [id]);
export const useRegistry = () => useCached("/registry");
export const useSkills = (subject) => useCached(`/skills?subject=${encodeURIComponent(subject)}`, [subject]);

// Per-unit local progress: which loop steps are done.
const UP_KEY = "mwq_unit_progress_v1";
export const LOOP = ["discover", "learn", "practise", "apply", "explain", "review"];
export function unitProgress(unitId) { try { return JSON.parse(localStorage.getItem(UP_KEY) || "{}")[unitId] || {}; } catch { return {}; } }
export function markStep(unitId, step) {
  let all = {}; try { all = JSON.parse(localStorage.getItem(UP_KEY) || "{}"); } catch { /* ignore */ }
  all[unitId] = { ...(all[unitId] || {}), [step]: new Date().toISOString() };
  try { localStorage.setItem(UP_KEY, JSON.stringify(all)); window.dispatchEvent(new Event("mwq-unit-progress")); } catch { /* ignore */ }
}
export function allUnitProgress() { try { return JSON.parse(localStorage.getItem(UP_KEY) || "{}"); } catch { return {}; } }
